// Enterprise Crews v2 API Repository(仮置き)
import http from "@/http/aisea/axios";
const resource = "/enterprises/manning/vessels/roles/positions";
import qs from "qs";

/**
 * 配乗可能船員一覧API
 */
export default {
  /**
   * 配乗可能船員一覧取得
   * 役職ID、日時から配乗可能船員一覧を取得する
   * @param {*} rolePositionId 役職ID
   * @param {*} payload
   * date:
   *  - YYYY-MM-DD形式の日時
   *
   * details:
   *   - CREW_AVAILABLE_ROLE
   *   - CREW_LICENSE
   *   - CREW_RESPONSIBILITY
   *
   * @returns
   */
  fetchByRolePostionId(rolePositionId, payload) {
    return http.get(`${resource}/${rolePositionId}/assignable/crews`, {
      params: payload,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
    });
  },
};
